import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../assets/images";
import DatePicker from "react-datepicker";
import { components } from "react-select";
import { CalenderIcon } from "../../components/Icon";
import Select from "react-select";

import moment from "moment";
import {
  CircularAvatar,
  DropDown,
  ToggleSwitch,
} from "../../components/commons";
import {
  callFrequencyDropDown,
  leadCategaryDropdown,
  leadStatusDropdown,
  turnOverDropdown,
} from "../../constant/clientDirectoryDropDown";
import { SelctOptionType } from "../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { SelectStageOptionType } from "../../commonTypes/clientDirectoryTypes";
type DropDownOptionType = {
  value: string | null;
  label: string;
};
type AppProps = {
  toggle: boolean;
  setToggle: (data: boolean) => void;
  finalUserList: DropDownOptionType[];
  fetching: boolean;
  limit: number;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  setText: (e: string) => void;
  stageLimit: number;
  filterStatus: string;
  filterStartDate: string;
  filterEndDate: string;
  multiSelectData: number[] | string[] | [];
  setStageText: (e: string) => void;
  handleApplyFilter: (data: any) => void;
  handleFilterClear: () => void;
  setStageOffset: React.Dispatch<React.SetStateAction<number>>;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
  setCallFrequency: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
  setFilterStartDate: React.Dispatch<React.SetStateAction<string>>;
  setFilterEndDate: React.Dispatch<React.SetStateAction<string>>;
  stage: DropDownOptionType;
  leadCategory: DropDownOptionType;
  callFrequency: DropDownOptionType;
  leadAssignTo: DropDownOptionType;
  setStage: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
  setLeadAssignTo: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
  setLeadCategory: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
  setClientCategoryFilter: React.Dispatch<
    React.SetStateAction<{ value: null | number; label: string }>
  >;
  setTurnOverFilter: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
  turnOverFilter: DropDownOptionType;
  setMigrateToFinacFilter: React.Dispatch<React.SetStateAction<boolean>>;
  migrateTofinacFilter: boolean;
  clientCategoryFilter: SelctOptionType;
  finalCategoryFilterList: any;
  handleClientCategoryChange: any;
  setCategoryOffset: React.Dispatch<React.SetStateAction<number>>;
  setCategoryText: React.Dispatch<React.SetStateAction<string>>;
  loginData: LoginResponseType;
  history: any;
  setScopeFilter: React.Dispatch<
    React.SetStateAction<{ value: null | number; label: string }>
  >;
  scopeFilter: SelctOptionType;
  finalScopeFilterList: any;
  handleScopeChange: any;
  setScopeOffset: React.Dispatch<React.SetStateAction<number>>;
  setScopeText: React.Dispatch<React.SetStateAction<string>>;
  cityFilter: DropDownOptionType;
  finalCityFilterOptions: DropDownOptionType[] | [];
  handleCityFilterChange: (e: any) => void;
  setCitySearchTerm: React.Dispatch<React.SetStateAction<string>>;
  setCityOffset: React.Dispatch<React.SetStateAction<number>>;
  cityFetching:boolean;
  leadStatusFilter: DropDownOptionType;
  setLeadStatusFilter: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
  stageDropDown:SelectStageOptionType[]
};

const LeadModuleListFilter = ({
  toggle,
  stage,
  leadCategory,
  setLeadCategory,
  leadAssignTo,
  setStage,
  setLeadAssignTo,
  setToggle,
  setFilterEndDate,
  setFilterStartDate,
  setStatus,
  finalUserList,
  setText,
  setCallFrequency,
  callFrequency,
  setStageOffset,
  stageLimit,
  setOffset,
  fetching,
  limit,
  loginData,
  history,
  clientCategoryFilter,
  finalCategoryFilterList,
  handleClientCategoryChange,
  setCategoryOffset,
  setCategoryText,
  setStageText,
  handleApplyFilter,
  handleFilterClear,
  filterStatus,
  filterStartDate,
  filterEndDate,
  multiSelectData,
  setTurnOverFilter,
  turnOverFilter,
  migrateTofinacFilter,
  setMigrateToFinacFilter,
  leadStatusFilter,
  setLeadStatusFilter,
  setClientCategoryFilter,
  setScopeFilter,
  scopeFilter,
  finalScopeFilterList,
  handleScopeChange,
  setScopeOffset,
  setScopeText,
  cityFilter,
  cityFetching,
  finalCityFilterOptions,
  handleCityFilterChange,
  setCitySearchTerm,
  setCityOffset,
  stageDropDown
}: AppProps) => {
  const filterCount: number = Object.values(multiSelectData).filter(
    (e: any) => {
      if (e?.hasOwnProperty("value")) {
        return e.value !== "" && e.value !== null;
      }
      return e !== "" && e !== false && e !== null;
    }
  ).length;

  const handleLeadAssignToDetailsChange = (data: any) => {
    setLeadAssignTo(data);
  };
  const handleLeadCategaryChange = (data: any) => {
    setLeadCategory(data);
  };
  const handleLeadStatusChange = (data: any) => {
    setLeadStatusFilter(data);
  };
  const handleTurnOverChange = (data: any) => {
    setTurnOverFilter(data);
  };

  const handleStageChange = (data: any) => {
    setStage({
      value: data?.value,
      label: data?.label,
    });
  };
  const handleCallFrequencyChange = (data: any) => {
    setCallFrequency({
      value: data?.value,
      label: data?.label,
    });
  };
  const filterEndDateChange = (date: any) => {
    if (date !== "Invalid date") {
      setFilterEndDate(date);
    } else {
      setFilterEndDate("");
    }
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          {data?.label !== "Select..." ? (
            <CircularAvatar
              name={data?.label}
              image={data?.image && data?.image}
            />
          ) : (
            <></>
          )}
          {data?.label}
        </div>
      </components.Option>
    );
  };
  const clearFilter = () => {
    setStatus("");
    setFilterEndDate("");
    setFilterStartDate("");
    setMigrateToFinacFilter(false);
    setStage({
      value: null,
      label: "Select..",
    });
    setLeadAssignTo({
      value: null,
      label: "Select..",
    });
    setLeadCategory({
      value: null,
      label: "Select..",
    });
    setClientCategoryFilter({
      value: null,
      label: "Select..",
    });
    setTurnOverFilter({
      value: null,
      label: "Select..",
    });
    setLeadStatusFilter({
      value: null,
      label: "Select..",
    });
    handleFilterClear();
  };

  const checkStageBottom = () => {
    setStageOffset((prv: number) => prv + stageLimit);
  };

  const handleToggle = () => {
    delete history?.location?.state?.filterData?.migrateTofinacFilter;
    setMigrateToFinacFilter(!migrateTofinacFilter);
  };

  const handleApplyFilterData = () => {
    const finalData = {
      filterStatus,
      filterStartDate,
      filterEndDate,
      stage: stage,
      callFrequency: callFrequency,
      leadAssignTo: leadAssignTo,
    };
    handleApplyFilter(finalData);
  };
  const filterStartDateChange = (date: any) => {
    if (date !== "Invalid date") {
      setFilterStartDate(date);
    } else {
      setFilterStartDate("");
    }
  };
  const empty = () => {
    const {
      filterStatus,
      filterStartDate,
      filterEndDate,
      stage,
      leadAssignTo,
      migrateToFinacFilter,
    }: any = multiSelectData;
    filterStartDateChange(filterStartDate);
    filterEndDateChange(filterEndDate);
    setLeadAssignTo(leadAssignTo);
    setStatus(filterStatus);
    setStage(stage);
    setMigrateToFinacFilter(migrateToFinacFilter);
  };
  const resetFilter = () => {
    setStatus("");
    setFilterEndDate("");
    setFilterStartDate("");
    setStage({
      value: null,
      label: "Select..",
    });
    setLeadAssignTo({
      value: null,
      label: "Select..",
    });
    setLeadCategory({
      value: null,
      label: "Select..",
    });
    setTurnOverFilter({
      value: null,
      label: "Select..",
    });
    setMigrateToFinacFilter(false);
  };
  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "100%",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "65%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: "150%",
      // position: 'absolute'
    }),
  };

  const checkBottom = (e: any) => {
    setCategoryOffset((prv: any) => prv + 20);
  };
  const checkScopeBottom = (e: any) => {
    setScopeOffset((prv: any) => prv + 20);
  };
  const checkCityBottom = (e: any) => {
    setCityOffset((prv: any) => prv + 20);
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        filterCount === 0 && toggle ? resetFilter() : empty();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <img src={filterCount !== 0 ? FilterIcon : filterBlackIcon} alt="" />
        <span className={filterCount !== 0 ? "filter-count" : ""}>
          <span>{filterCount !== 0 ? filterCount : ""}</span>
        </span>
      </DropdownToggle>
      <DropdownMenu right style={{ width: "400px", padding: "15px 25px 30px" }}>
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Filter</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        <hr className="mt-0 mb-2" />
        {/* <span>Filter Data For Lead Received On</span> */}
        <div className="row mt-3">
          <div className="d-flex">
            <div className="form-group col-md-6">
              <div className="date-picker-wraper mr-0 position-relative">
                <Label className="mb-1 p-0 w-100" style={{ fontSize: "14px" }}>
                  Start Date
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      filterStartDate
                        ? new Date(
                            moment(
                              `${filterStartDate}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      filterStartDateChange(moment(e).format("YYYY-MM-DD"));
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    name="filterStartDate"
                    placeholderText="Select"
                    className="form-control"
                  />
                  <span
                    className="calender-icon pr-3"
                    style={{
                      top: "28px",
                      right: "4px",
                      cursor: "pointer",
                      position: "absolute",
                    }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <div className="date-picker-wraper mr-0">
                  <Label
                    className="mb-1 p-0 w-100"
                    style={{ fontSize: "14px" }}
                  >
                    End Date
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={
                        filterEndDate
                          ? new Date(
                              moment(
                                `${filterEndDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) => {
                        filterEndDateChange(moment(e).format("YYYY-MM-DD"));
                      }}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="filterEndDate"
                      placeholderText="Select"
                      className="form-control"
                      minDate={
                        filterStartDate
                          ? new Date(
                              moment(
                                `${filterStartDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                    />
                    <span
                      className="calender-icon pr-3"
                      style={{ top: "28px", right: "20px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex">
          <div className="col-md-6">
            <Label className="mb-1" style={{ fontSize: "14px" }}>
              Stage
            </Label>

            <DropDown
              style={dropDownStyle}
              options={
                stageDropDown?.length
                  ? [{ label: "Select...", value: null }, ...stageDropDown]
                  : [{ label: "Select...", value: null }]
              }
              value={stage}
              handleChange={handleStageChange}
            />
          </div>
          <div className="col-md-6">
            <Label className="mb-1" style={{ fontSize: "14px" }}>
              Lead Assign To
            </Label>
            <Select
              options={
                finalUserList?.length > 0
                  ? [{ label: "Select...", value: null }, ...finalUserList]
                  : [{ label: "Select...", value: null }]
              }
              styles={dropDownStyle}
              value={leadAssignTo}
              components={{ Option }}
              onChange={(e) => handleLeadAssignToDetailsChange(e)}
              isSearchable={true}
              isLoading={fetching}
              onMenuClose={() => setStageOffset(0)}
              onMenuScrollToBottom={checkStageBottom}
              onInputChange={(e) => {
                setStageText(e);
                setStageOffset(0);
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className=" col-md-6 mt-3">
            <label
              className="mb-1"
              htmlFor="Stage"
              style={{ fontSize: "14px" }}
            >
              Lead Category
            </label>
            <DropDown
              options={
                leadCategaryDropdown?.length > 0
                  ? [
                      { label: "Select...", value: null },
                      ...leadCategaryDropdown,
                    ]
                  : [{ label: "Select...", value: null }]
              }
              value={leadCategory}
              handleChange={handleLeadCategaryChange}
            />
          </div>
          <div className=" col-md-6 mt-3">
            <label
              className="mb-1"
              htmlFor="Stage"
              style={{ fontSize: "14px" }}
            >
              Turnover(crore)
            </label>
            <DropDown
              options={
                turnOverDropdown?.length > 0
                  ? [{ label: "Select...", value: null }, ...turnOverDropdown]
                  : [{ label: "Select...", value: null }]
              }
              value={turnOverFilter}
              handleChange={handleTurnOverChange}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mt-4">
            <label>Client Category</label>
            <Select
              className="dropdown"
              placeholder={
                <div style={{ color: "hsl(0, 0%, 20%)" }}>Select...</div>
              }
              value={clientCategoryFilter}
              options={[
                { label: "Select...", value: null },
                ...finalCategoryFilterList,
              ]}
              onChange={handleClientCategoryChange}
              isLoading={fetching}
              isSearchable={true}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              onInputChange={(e: string) => {
                setCategoryText(e);
                setCategoryOffset(0);
              }}
            />
          </div>

          <div className="col-md-6 mt-4">
            <label>City</label>
            <Select
              className="dropdown"
              placeholder={
                <div style={{ color: "hsl(0, 0%, 20%)" }}>Select...</div>
              }
              value={cityFilter}
              options={[
                { label: "Select...", value: null },
                ...finalCityFilterOptions,
              ]}
              onChange={handleCityFilterChange}
              isLoading={cityFetching}
              isSearchable={true}
              onMenuScrollToBottom={(e: any) => checkCityBottom(e)}
              onInputChange={(e: string) => {
                setCitySearchTerm(e);
                setCityOffset(0);
              }}
            />
          </div>
        </div>

        {/*  */}
        {/* scope of work */}
        <div className="row">
          <div className="col-md-6 mt-4">
            <label>Scope of Work</label>
            <Select
              className="dropdown"
              placeholder={
                <div style={{ color: "hsl(0, 0%, 20%)" }}>Select...</div>
              }
              value={scopeFilter}
              options={
                finalScopeFilterList?.length > 0
                  ? [{ label: "Select", value: null }, ...finalScopeFilterList]
                  : []
              }
              onChange={handleScopeChange}
              isLoading={fetching}
              isSearchable={true}
              onMenuScrollToBottom={(e: any) => checkScopeBottom(e)}
              onInputChange={(e: string) => {
                setScopeText(e);
                setScopeOffset(0);
              }}
            />
          </div>

          <div className="col-md-6 mt-4">
            <label
              className="mb-1"
              htmlFor="Stage"
              style={{ fontSize: "14px" }}
            >
              Lead Status
            </label>
            <DropDown
              value={leadStatusFilter}
              options={
                leadStatusDropdown?.length > 0
                  ? [{ label: "Select...", value: null }, ...leadStatusDropdown]
                  : [{ label: "Select...", value: null }]
              }
              handleChange={handleLeadStatusChange}
            />
          </div>
        </div>

        <label
          className="mb-1 mt-4"
          htmlFor="Stage"
          style={{ fontSize: "14px" }}
        >
          Ready to migrate in finac
        </label>
        <div>
          <ToggleSwitch
            handleToggleChange={handleToggle}
            isChecked={migrateTofinacFilter}
          />
        </div>

        <div className="d-flex align-items-center justify-content-end mt-3">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="pl-4 pr-4 btn btn-primary"
            onClick={() => {
              handleApplyFilterData();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default LeadModuleListFilter;
